import { indexData } from '@/mocks/home';

const coverImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20editorial%20visual%20with%20subtle%20red%20and%20gold%20accents%2C%20modern%20entertainment%20media%20cover%2C%20cinematic%20texture%2C%20dark%20background%20with%20warm%20atmospheric%20lighting&width=120&height=120&seq=index-cover-1&orientation=squarish',
  2: 'https://readdy.ai/api/search-image?query=Mysterious%20abstract%20dark%20composition%20with%20crimson%20highlights%2C%20editorial%20media%20thumbnail%2C%20professional%20news%20portal%20style%2C%20dark%20atmospheric%20background&width=120&height=120&seq=index-cover-2&orientation=squarish',
  3: 'https://readdy.ai/api/search-image?query=Modern%20dark%20abstract%20visual%20with%20golden%20geometric%20accents%2C%20entertainment%20news%20cover%20design%2C%20dramatic%20lighting%2C%20editorial%20style%2C%20dark%20background&width=120&height=120&seq=index-cover-3&orientation=squarish',
  4: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20design%20with%20red%20and%20amber%20highlights%2C%20media%20cover%20thumbnail%2C%20professional%20editorial%20aesthetic%2C%20mysterious%20atmosphere&width=120&height=120&seq=index-cover-4&orientation=squarish',
  5: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20editorial%20visual%20with%20warm%20gold%20accents%2C%20entertainment%20portal%20cover%2C%20modern%20minimalist%20design%2C%20dark%20cinematic%20background&width=120&height=120&seq=index-cover-5&orientation=squarish',
  6: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20abstract%20art%20with%20crimson%20geometric%20elements%2C%20news%20media%20cover%2C%20professional%20editorial%20style%2C%20dramatic%20lighting&width=120&height=120&seq=index-cover-6&orientation=squarish',
  7: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20composition%20with%20golden%20and%20red%20abstract%20shapes%2C%20entertainment%20cover%20thumbnail%2C%20editorial%20design%2C%20cinematic%20dark%20background&width=120&height=120&seq=index-cover-7&orientation=squarish',
  8: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20visual%20with%20warm%20amber%20highlights%2C%20media%20portal%20cover%2C%20professional%20editorial%20aesthetic%2C%20mysterious%20cinematic%20texture&width=120&height=120&seq=index-cover-8&orientation=squarish',
  9: 'https://readdy.ai/api/search-image?query=Modern%20dark%20abstract%20design%20with%20crimson%20geometric%20accents%2C%20entertainment%20news%20cover%2C%20editorial%20style%2C%20dramatic%20dark%20background&width=120&height=120&seq=index-cover-9&orientation=squarish',
};

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          专题索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          精选专题合集，快速定位你感兴趣的内容方向
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex items-center gap-4 p-4 bg-background-100 hover:bg-background-200/60 border border-background-200/60 hover:border-accent-500/30 rounded-lg transition-all duration-200 cursor-pointer"
            >
              <div className="w-16 h-16 shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={coverImages[item.id]}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs bg-accent-100 text-accent-700 px-1.5 py-0.5 rounded">{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.count}篇</span>
                </div>
                <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors truncate">
                  {item.title}
                </p>
              </div>
              <span className="text-foreground-400 group-hover:text-primary-400 transition-colors shrink-0">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}